export default __webpack_public_path__ + "static/media/Medium-branded-DeepRacer-GUI-bordered-350px-224px.441a1b36.jpg";